import * as R from "ramda";

export function nullOrValue<T extends {}>(value: T | null | undefined): T | null {
    return R.isNil(value) ? null : value;
}  